import { registerPlugin } from '@capacitor/core';
const DBR = registerPlugin('DBR', {
    web: () => import('./web').then(m => new m.DBRWeb()),
});
export * from './definitions';
export { DBR };
//# sourceMappingURL=index.js.map